// extracted by mini-css-extract-plugin
export default {"listContainer":"PokemonList_listContainer__TZ5sV","pokeGrid":"PokemonList_pokeGrid__giUBW","pageControl":"PokemonList_pageControl__m7Scl"};